import { object, number, preprocess, boolean, string, ZodIssueCode } from 'zod';

import { makeZodValidate as makeValidate } from '@occc-app/design-system';
import { IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';
import { PromptAtPumpSchema } from '@occc-app/routes/CampaignComponents/PromptAtPump/validation';
import {
  AwardRestrictionsSchema,
  AwardVouchersSchema,
  CustomDataSchema,
  OfferFulfillmentPrioritySchema,
  OfferNameAndDescriptionSchema,
  VoucheredOfferSchema,
} from '@occc/validation';
import { LimitSchema, validateMembershipLessThanGlobal } from '@occc/feat-limits';
import { FulfillmentChannelConstraintSchema } from '@occc/feat-constraints/schemas';

const PointSpendSchema = object({
  id: string().optional(),
  pointCost: number({ required_error: IS_REQUIRED }),
  allowedForNewMember: boolean().optional(),
});

const RewardAwardCountSchema = object({
  membership: LimitSchema,
  global: LimitSchema,
}).superRefine((data, ctx) => {
  const { membership, global } = data;
  validateMembershipLessThanGlobal({ membership, global, ctx });
});

const RewardAwardVouchersSchema = AwardVouchersSchema.extend({
  voucheredOffer: preprocess((data) => data ?? undefined, VoucheredOfferSchema),
  isEnabled: boolean().optional(),
}).superRefine((data, ctx) => {
  if ((data.isEnabled ?? false) && data.voucherExpirationDays == null) {
    ctx.addIssue({
      code: ZodIssueCode.custom,
      path: ['voucherExpirationDays'],
      message: IS_REQUIRED,
    });
  }
});

export const ConfigurationSchema = OfferNameAndDescriptionSchema.merge(
  OfferFulfillmentPrioritySchema,
).extend({
  isOfferReturnable: boolean(),
  pointSpend: preprocess((data) => data ?? {}, PointSpendSchema),
  awardVouchers: RewardAwardVouchersSchema,
  awardCount: RewardAwardCountSchema,
  promptAtPump: PromptAtPumpSchema,
  awardRestrictions: AwardRestrictionsSchema,
  customData: CustomDataSchema,
  fulfillmentChannelConstraint: FulfillmentChannelConstraintSchema,
});

export const validateConfiguration = makeValidate(ConfigurationSchema);
